module.exports = __webpack_public_path__ + "static/media/valentino.b37d09b5.png";